import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, FileText, Package } from "lucide-react";
import { PortalShell } from "./PortalShell";
import { portalApi, downloadFile, inr } from "./portalApi";
import "../test/testTheme.css";

function PurchasesInner() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => {
    portalApi.get("/store/my-purchases").then(({ data: d }) => setData(d)).catch(() => setError("Could not load your purchases. Please refresh."));
  }, []);

  const download = async (seriesId, kind, name) => {
    setBusy(`${seriesId}:${kind}`);
    try {
      await downloadFile(`/store/series/${seriesId}/${kind}`, `${name}${kind === "solutions" ? " - Solutions" : ""}.pdf`);
    } catch { setError("Could not download. Please try again."); } finally { setBusy(""); }
  };

  return (
    <div className="tp-wrap" style={{ maxWidth: 820, padding: "44px 22px 70px" }}>
      <div className="tp-eyebrow">MY PURCHASES</div>
      <h1 className="tp-h2" style={{ fontSize: 32 }} data-testid="purchases-title">Everything you own, in one place</h1>
      {error && <p className="tp-error" role="alert" data-testid="purchases-error">{error}</p>}
      {!data ? <p className="tp-muted">Loading…</p> : data.purchases.length === 0 ? (
        <div className="tp-panel" style={{ textAlign: "center" }} data-testid="purchases-empty">
          <Package size={28} style={{ color: "#f77f00", marginBottom: 8 }} />
          <p className="tp-muted">Nothing purchased yet. Browse the store for chapter-wise test papers and more.</p>
          <Link className="tp-btn" to="/portal/store" data-testid="purchases-goto-store">BROWSE TEST SERIES</Link>
        </div>
      ) : (
        <div data-testid="purchases-list">
          {data.purchases.map((p, i) => (
            <div className="tp-panel" key={`${p.item_type}-${p.item_id}`} style={{ marginBottom: 14 }} data-testid={`purchase-${i}`}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                <div>
                  <span className="tp-pill info">{p.item_type === "series" ? "TEST PAPER" : "PRODUCT"}</span>
                  <h3 style={{ margin: "8px 0 4px", fontSize: 17 }}>{p.item.name}</h3>
                  <p className="tp-note">Purchased {new Date(p.created_at * 1000).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })} · {inr(p.item.price_paise || 0)} · Order {p.order_id}</p>
                </div>
                {p.item_type === "series" && (
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button className="tp-btn small" disabled={busy === `${p.item_id}:download`} onClick={() => download(p.item_id, "download", p.item.name)} data-testid={`purchase-download-${i}`}><Download size={14} /> {busy === `${p.item_id}:download` ? "Preparing…" : "Download test"}</button>
                    {p.item.has_solutions && <button className="tp-btn secondary small" disabled={busy === `${p.item_id}:solutions`} onClick={() => download(p.item_id, "solutions", p.item.name)} data-testid={`purchase-solutions-${i}`}><FileText size={14} /> Solutions</button>}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function PortalPurchases() {
  return <PortalShell><PurchasesInner /></PortalShell>;
}
